import React, { useState, useEffect } from "react";
import {
  MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarToggler, MDBIcon, MDBNavbarNav,
  MDBNavbarItem, MDBNavbarLink, MDBCollapse, MDBBadge
} from "mdb-react-ui-kit";

const Navbar=()=>{
    const [showNav, setShowNav] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 993);
    const cartCount = JSON.parse(localStorage.getItem("cart"))?.length??0;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 993);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const style = {
        position: "absolute",
        cursor: "pointer",
        right: isMobile ? 40 : 0
    };

    const showCart=()=>{
        window.location.href = "/checkout";
    }

    return (
        <MDBNavbar expand="lg" dark fixed="top" style={{backgroundColor: "#6B2E06", color: "#F4E5D1"}}>
        <MDBContainer fluid>
            <MDBNavbarBrand href="/" style={{color: "#F4E5D1", fontWeight: "bolder"}}>
            <img alt="" src="/android-chrome-192x192.png" width="40"/> {"ÀBÉJÍKẸ́"}
            </MDBNavbarBrand>
            <MDBNavbarToggler type="button" onClick={() => setShowNav(!showNav)}>
                <MDBIcon icon="bars" fas />
            </MDBNavbarToggler>
            <MDBCollapse navbar open={showNav}>
                <MDBNavbarNav right fullWidth={false} className="mb-2 mb-lg-0">
                    <MDBNavbarItem>
                        <MDBNavbarLink href="/men">MEN</MDBNavbarLink>
                    </MDBNavbarItem>
                    <MDBNavbarItem>
                        <MDBNavbarLink href="/women">WOMEN</MDBNavbarLink>
                    </MDBNavbarItem>
                    <MDBNavbarItem>
                        <MDBNavbarLink href="/kids">KIDS</MDBNavbarLink>
                    </MDBNavbarItem>
                    <MDBNavbarItem>
                        <MDBNavbarLink href="/fabrics">FABRICS</MDBNavbarLink>
                    </MDBNavbarItem>
                    <MDBNavbarItem>
                        <MDBNavbarLink href="/skincare">BEAUTY & SKINCARE</MDBNavbarLink>
                    </MDBNavbarItem>
                    <MDBNavbarItem>
                        <MDBNavbarLink href="/accessories">ACCESSORIES</MDBNavbarLink>
                    </MDBNavbarItem>
                    <MDBNavbarItem>
                        <MDBNavbarLink className="ltr" tag="div" style={{ cursor: "default", color: "lightblue" }}>Free shipping on orders over $50</MDBNavbarLink>
                    </MDBNavbarItem>
                </MDBNavbarNav>
            </MDBCollapse>
        </MDBContainer>
        {cartCount > 0 &&<div style={style} className='mx-3'>
            <MDBIcon color="light" fas icon='shopping-cart' size='lg' onClick={showCart} />
            <MDBBadge color='danger' notification pill>{cartCount}</MDBBadge>
        </div>}
    </MDBNavbar>
    );
}
export default Navbar;